import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phone',
})
export class PhonePipe implements PipeTransform {
    transform(value?: string | null, isInternational?: boolean | null): string {
        if (!value) {
            return '';
        }

        // Clean of all symbols.
        const cleaned = value.replace(/[\-\.\ \(\)]/g, '');

        if (isInternational) {
            return cleaned;
        }

        const area = cleaned.length >= 3 ? cleaned.substr(0, 3) : cleaned;
        const exchange = cleaned.length >= 6 ? cleaned.substr(3, 3) : cleaned.substr(3);
        const subscrib = cleaned.length >= 8 ? cleaned.substr(6) : '';

        return `(${area}) ${exchange}-${subscrib}`;
    }
}
